<template>
  <div>
    <Echart
      :options="options"
      :id="cdata.id"
      :height="curHeight+'px'"
      :width="curWidth+'px'"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
import {getSizeByScreen} from '@/utils/index'

export default {
  data () {
    return {
      options: {},
      curHeight:'',
      curWidth:''
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
    width: {
      type: String,
      default: '100'
    },
    height: {
      type: String,
      default: '100'
    },
  },
  watch: {
    cdata: {
      handler (newData) {
        this.options= {
          color:['#43FFB9','#1F3762'],
          tooltip: {
              trigger: 'item'
          },
          graphic:{
            type:"text",
            left:"center",
            top:"center",
            style:{
              text:newData.text||"",
              textAlign:"center",
              fill:"#fff",
              fontSize:12,
              fontWeight:400
            },
          },
          series:newData.series?newData.series: [
            {
            name: '访问来源',
            type: 'pie',
            radius: ['50%', '70%'],
            center:['50%','50%'],
            data: [
              {value: 0},
              {value: 0},
            ],
            labelLine: {
              show: false
            },
            label:{
              show:true,
            }
            },
          ] 
        }
      },
      immediate: true,
      deep: true
    },
    curWidth:{
      handler (newData) {
        this.curWidth = this.width;
        //适配代码
        // this.curWidth = getSizeByScreen(this.width);
      },
      immediate: true,
      deep: true
    },
    curHeight:{
      handler (newData) {
        this.curHeight = this.height;
        //适配代码
        // this.curHeight = getSizeByScreen(this.height);
      },
      immediate: true,
      deep: true
    }
  }
}
</script>